export const toYear = (yearStr: string): string => {
    const left = +yearStr.substr(0, 4);
    const right = left - 2000 + 1;
    return `${left}/${right}`;
};

export class BusinessError extends Error {
}

export const firstElm = (list: any[], ifEmpty = null): any => {
    if (list.length > 0) {
        return list[0];
    }
    return ifEmpty;
};
